import { useState, useEffect } from "react";
import {
  Col,
  Row,
  Button,
  Input,
  Form,
  Upload,
  message,
} from "antd";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import DashbordSidebar from "../../../components/DashboardSidebar";
import "react-phone-number-input/style.css";
import swal from "sweetalert";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { PROFILE, UPLOADS_URL } from "../../../config/constants/api";
import { Post } from "../../../config/api/post";

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const beforeUpload = (file) => {
  const isImage = file.type.startsWith("image/");
  if (!isImage) {
    message.error("Invalid Uplaod, You can only upload image files!");
  }
  return isImage;
};
const DropzoneFiltercards = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  // const userData = useSelector((state) => state.user.userData);
  const location = useLocation();
  const userData = location?.state?.userData;
  // const [imageUrl, setImageUrl] = useState("");
  const token = useSelector((state) => state.user.userToken);
  const [selfieUrl, setSelfieUrl] = useState("");
  const [selfieObject, setSelfieObject] = useState(null);

  const [dmvFrontUrl, setDmvFrontUrl] = useState("");
  const [dmvFrontObject, setDmvFrontObject] = useState(null);

  const [dmvBackUrl, setDmvBackUrl] = useState("");
  const [dmvBackObject, setDmvBackObject] = useState(null);

  const [tlcFrontUrl, setTlcFrontUrl] = useState("");
  const [tlcFrontObject, setTlcFrontObject] = useState(null);

  const [tlcBackUrl, setTlcBackUrl] = useState("");
  const [tlcBackObject, setTlcBackObject] = useState(null);

  const [insuranceUrl, setInsuranceUrl] = useState("");
  const [insuranceObject, setInsuranceObject] = useState(null);

  const [registerationUrl, setRegisterationUrl] = useState("");
  const [registerationObject, setRegisterationObject] = useState(null);
  useEffect(() => {
    form.setFieldsValue({
      firstName: userData?.firstName,
      lastName: userData?.lastName,
      email: userData?.email,
      bankTitle: userData?.bankTitle,
      bankAccountNo: userData?.bankAccountNo,
      phoneNumber: userData?.phone,
      routingNo: userData?.routingNo,
    });
    setSelfieUrl(UPLOADS_URL + userData?.image);
    setDmvFrontUrl(UPLOADS_URL + userData?.dmvFront);
    setDmvBackUrl(UPLOADS_URL + userData?.dmvBack);
    setTlcFrontUrl(UPLOADS_URL + userData?.tlcFront);
    setTlcBackUrl(UPLOADS_URL + userData?.tlcBack);
    setInsuranceUrl(UPLOADS_URL + userData?.insurance);
    setRegisterationUrl(UPLOADS_URL + userData?.registeration);
    // eslint-disable-next-line
  }, []);

  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const onFinish = (values) => {
    const {
      firstName,
      lastName,
      bankTitle,
      bankAccountNo,
      phoneNumber,
      routingNo,
    } = values;

    const formValuesChanged = () => {
      return (
        userData?.firstName !== firstName ||
        userData?.lastName !== lastName ||
        userData?.bankTitle !== bankTitle ||
        userData?.bankAccountNo !== bankAccountNo ||
        userData?.phone !== phoneNumber ||
        userData?.routingNo !== routingNo ||
        selfieObject ||
        dmvFrontObject ||
        dmvBackObject ||
        tlcFrontObject ||
        tlcBackObject ||
        insuranceObject ||
        registerationObject
      );
    };

    if (formValuesChanged()) {
      let data = new FormData();
      if (selfieObject) {
        data.append("image", selfieObject);
      }
      if (dmvFrontObject) {
        data.append("dmvFront", dmvFrontObject);
      }
      if (dmvBackObject) {
        data.append("dmvBack", dmvBackObject);
      }
      if (tlcFrontObject) {
        data.append("tlcFront", tlcFrontObject);
      }
      if (tlcBackObject) {
        data.append("tlcBack", tlcBackObject);
      }
      if (insuranceObject) {
        data.append("insurance", insuranceObject);
      }
      if (registerationObject) {
        data.append("registeration", registerationObject);
      }
      data.append("firstName", firstName);
      data.append("lastName", lastName);
      data.append("bankTitle", bankTitle);
      data.append("bankAccountNo", bankAccountNo);
      data.append("phone", phoneNumber);
      data.append("routingNo", routingNo);
      Post(PROFILE.updateProfile, data, token, null, "multipart")
        .then((response) => {
          if (response.status) {
            form.resetFields();
            swal("Success", response?.message, "success");
            navigate("/Profile");
          }
        })
        .catch((err) => {
          let message = err?.response?.data?.message || err?.message;
          if (message) {
            swal("Error", message, "error");
          }
          console.log("Error", err);
        });
    } else {
      swal("System Alert", "No Changes Detected", "error");
      return;
    }
  };

  const handleChangepro = (info, name) => {
    setLoading(true);
    getBase64(
      info?.fileList[info?.fileList?.length - 1]?.originFileObj,
      (url) => {
        if (name === "selfie") {
          setSelfieObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setSelfieUrl(url);
        } else if (name === "dmvFront") {
          setDmvFrontObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setDmvFrontUrl(url);
        } else if (name === "dmvBack") {
          setDmvBackObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setDmvBackUrl(url);
        } else if (name === "tlcFront") {
          setTlcFrontObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setTlcFrontUrl(url);
        } else if (name === "tlcBack") {
          setTlcBackObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setTlcBackUrl(url);
        } else if (name === "insurance") {
          setInsuranceObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setInsuranceUrl(url);
        } else if (name === "registeration") {
          setRegisterationObject(
            info?.fileList[info?.fileList?.length - 1]?.originFileObj
          );
          setRegisterationUrl(url);
        }
        setLoading(false);
      }
    );
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  // const onChange = (date, dateString) => {
    // console.log(date, dateString);
  // };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  return (
    <div className="shop-page">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        <Col xs={23} md={21}>
          <div className="shop-page-main">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={24} lg={24} xl={24}>
                <div className="my-account-profile">
                  <section className="side-menu-parent">
                    <DashbordSidebar />
                    <div className="about-us-section">
                      <div className="profile-information-wrapper">
                        <h3 className="main-heading">Edit Profile</h3>
                      </div>
                      <div className="bg-parent">
                        <Row
                          gutter={[16, 16]}
                          align={""}
                          justify={"space-between"}
                        >
                          <Col md={23} lg={22} xl={22}>
                            <div className="">
                              <div className="logo-rectangle">
                                <div className="edit-profile-info">
                                  <Form
                                    className="row g-3"
                                    name="basic"
                                    layout="vertical"
                                    initialValues={{
                                      remember: true,
                                    }}
                                    onFinish={onFinish}
                                    onFinishFailed={onFinishFailed}
                                    autoComplete="off"
                                    form={form}
                                  >
                                    <Row
                                      style={{
                                        width: "100%",
                                        justifyContent: "center",
                                      }}
                                      gutter={[16, 16]}
                                      className="row-res-margin-0"
                                    >
                                      <Col lg={24} md={24} xs={24}>
                                        <div
                                          className="wrapper-group-1000001858"
                                          style={{
                                            height: "150px",
                                            borderRadius: "100px",
                                            width: "150px",
                                            margin: "10px auto",
                                          }}
                                        >
                                          <>
                                            <Upload
                                              name="image"
                                              showUploadList={false}
                                              style={{ position: "relative" }}
                                              onChange={(e) => {
                                                handleChangepro(e, "selfie");
                                              }}
                                              beforeUpload={beforeUpload}
                                            >
                                              {" "}
                                              <div
                                                style={{
                                                  height: "150px",
                                                  border: "1px solid gray",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  borderRadius: "100px",
                                                  width: "150px",
                                                  margin: "0 auto",
                                                }}
                                              >
                                                {selfieUrl ? (
                                                  <img
                                                    src={selfieUrl}
                                                    alt="avatar"
                                                    style={{
                                                      width: "90%",
                                                      height: "140px",
                                                      objectPosition: "center",
                                                      objectFit: "cover",
                                                      borderRadius: "100px",
                                                    }}
                                                  />
                                                ) : (
                                                  uploadButton
                                                )}
                                              </div>{" "}
                                            </Upload>
                                          </>
                                        </div>
                                      </Col>
                                      <Col lg={12} md={12} xs={24}>
                                        <Form.Item
                                          label="First Name"
                                          name="firstName"
                                        >
                                          <Input
                                            size="large"
                                            placeholder="Enter First Name"
                                            className="web-input"
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col lg={12} md={12} xs={24}>
                                        <Form.Item
                                          label="Last Name"
                                          name="lastName"
                                        >
                                          <Input
                                            size="large"
                                            placeholder="Enter Email Address"
                                            className="web-input"
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col lg={12} md={12} xs={24}>
                                        <Form.Item
                                          label="Email Address"
                                          name="email"
                                        >
                                          <Input
                                            size="large"
                                            placeholder="James.Anderson@gmail.com"
                                            className="web-input"
                                            disabled
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col lg={12} md={12} xs={24}>
                                        <Form.Item
                                          label="Phone Number"
                                          name="phoneNumber"
                                        >
                                          <Input
                                            size="large"
                                            placeholder="Enter Phone Number"
                                            className="web-input"
                                          />
                                        </Form.Item>
                                      </Col>
                                      {/* New document uploads */}
                                      <Col lg={12} md={12} xs={24}>
                                        <label>DMV Front</label>
                                        <div
                                          className="wrapper-group-1000001858"
                                          style={{
                                            height: "200px",
                                            borderRadius: "100px",
                                            width: "100%",
                                            margin: "0 auto",
                                          }}
                                        >
                                          <>
                                            <Upload
                                              name="image"
                                              showUploadList={false}
                                              style={{ position: "relative" }}
                                              onChange={(e) => {
                                                handleChangepro(e, "dmvFront");
                                              }}
                                              beforeUpload={beforeUpload}
                                            >
                                              <div
                                                style={{
                                                  height: "200px",
                                                  border: "1px solid gray",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                  margin: "0 auto",
                                                }}
                                              >
                                                {dmvFrontUrl ? (
                                                  <img
                                                    src={dmvFrontUrl}
                                                    alt="avatar"
                                                    style={{
                                                      width: "98%",
                                                      height: "194px",
                                                      objectPosition: "center",
                                                      objectFit: "cover",
                                                    }}
                                                  />
                                                ) : (
                                                  uploadButton
                                                )}
                                              </div>
                                            </Upload>
                                          </>
                                        </div>
                                      </Col>
                                      <Col lg={12} md={12} xs={24}>
                                        <label>DMV Back</label>
                                        <div
                                          className="wrapper-group-1000001858"
                                          style={{
                                            height: "200px",
                                            borderRadius: "100px",
                                            width: "100%",
                                            margin: "0 auto",
                                          }}
                                        >
                                          <>
                                            <Upload
                                              name="image"
                                              showUploadList={false}
                                              style={{ position: "relative" }}
                                              onChange={(e) => {
                                                handleChangepro(e, "dmvBack");
                                              }}
                                              beforeUpload={beforeUpload}
                                            >
                                              <div
                                                style={{
                                                  height: "200px",
                                                  border: "1px solid gray",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                  margin: "0 auto",
                                                }}
                                              >
                                                {dmvBackUrl ? (
                                                  <img
                                                    src={dmvBackUrl}
                                                    alt="avatar"
                                                    style={{
                                                      width: "98%",
                                                      height: "194px",
                                                      objectPosition: "center",
                                                      objectFit: "cover",
                                                    }}
                                                  />
                                                ) : (
                                                  uploadButton
                                                )}
                                              </div>
                                            </Upload>
                                          </>
                                        </div>
                                      </Col>
                                      <Col lg={12} md={12} xs={24}>
                                        <label>TLC Front</label>
                                        <div
                                          className="wrapper-group-1000001858"
                                          style={{
                                            height: "200px",
                                            borderRadius: "100px",
                                            width: "100%",
                                            margin: "0 auto",
                                          }}
                                        >
                                          <>
                                            <Upload
                                              name="image"
                                              showUploadList={false}
                                              style={{ position: "relative" }}
                                              onChange={(e) => {
                                                handleChangepro(e, "tlcFront");
                                              }}
                                              beforeUpload={beforeUpload}
                                            >
                                              <div
                                                style={{
                                                  height: "200px",
                                                  border: "1px solid gray",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                  margin: "0 auto",
                                                }}
                                              >
                                                {tlcFrontUrl ? (
                                                  <img
                                                    src={tlcFrontUrl}
                                                    alt="avatar"
                                                    style={{
                                                      width: "98%",
                                                      height: "194px",
                                                      objectPosition: "center",
                                                      objectFit: "cover",
                                                    }}
                                                  />
                                                ) : (
                                                  uploadButton
                                                )}
                                              </div>
                                            </Upload>
                                          </>
                                        </div>
                                      </Col>
                                      <Col lg={12} md={12} xs={24}>
                                        <label>TLC Back</label>
                                        <div
                                          className="wrapper-group-1000001858"
                                          style={{
                                            height: "200px",
                                            borderRadius: "100px",
                                            width: "100%",
                                            margin: "0 auto",
                                          }}
                                        >
                                          <>
                                            <Upload
                                              name="image"
                                              showUploadList={false}
                                              style={{ position: "relative" }}
                                              onChange={(e) => {
                                                handleChangepro(e, "tlcBack");
                                              }}
                                              beforeUpload={beforeUpload}
                                            >
                                              <div
                                                style={{
                                                  height: "200px",
                                                  border: "1px solid gray",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                  margin: "0 auto",
                                                }}
                                              >
                                                {tlcBackUrl ? (
                                                  <img
                                                    src={tlcBackUrl}
                                                    alt="avatar"
                                                    style={{
                                                      width: "98%",
                                                      height: "194px",
                                                      objectPosition: "center",
                                                      objectFit: "cover",
                                                    }}
                                                  />
                                                ) : (
                                                  uploadButton
                                                )}
                                              </div>
                                            </Upload>
                                          </>
                                        </div>
                                      </Col>
                                      <Col lg={12} md={12} xs={24}>
                                        <label>Insurance</label>
                                        <div
                                          className="wrapper-group-1000001858"
                                          style={{
                                            height: "200px",
                                            borderRadius: "100px",
                                            width: "100%",
                                            margin: "0 auto",
                                          }}
                                        >
                                          <>
                                            <Upload
                                              name="image"
                                              showUploadList={false}
                                              style={{ position: "relative" }}
                                              onChange={(e) => {
                                                handleChangepro(e, "insurance");
                                              }}
                                              beforeUpload={beforeUpload}
                                            >
                                              <div
                                                style={{
                                                  height: "200px",
                                                  border: "1px solid gray",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                  margin: "0 auto",
                                                }}
                                              >
                                                {insuranceUrl ? (
                                                  <img
                                                    src={insuranceUrl}
                                                    alt="avatar"
                                                    style={{
                                                      width: "98%",
                                                      height: "194px",
                                                      objectPosition: "center",
                                                      objectFit: "cover",
                                                    }}
                                                  />
                                                ) : (
                                                  uploadButton
                                                )}
                                              </div>
                                            </Upload>
                                          </>
                                        </div>
                                      </Col>
                                      <Col lg={12} md={12} xs={24}>
                                        <label>Registerations</label>
                                        <div
                                          className="wrapper-group-1000001858"
                                          style={{
                                            height: "200px",
                                            borderRadius: "100px",
                                            width: "100%",
                                            margin: "0 auto",
                                          }}
                                        >
                                          <>
                                            <Upload
                                              name="image"
                                              showUploadList={false}
                                              style={{ position: "relative" }}
                                              onChange={(e) => {
                                                handleChangepro(
                                                  e,
                                                  "registeration"
                                                );
                                              }}
                                              beforeUpload={beforeUpload}
                                            >
                                              <div
                                                style={{
                                                  height: "200px",
                                                  border: "1px solid gray",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                  margin: "0 auto",
                                                }}
                                              >
                                                {registerationUrl ? (
                                                  <img
                                                    src={registerationUrl}
                                                    alt="avatar"
                                                    style={{
                                                      width: "98%",
                                                      height: "194px",
                                                      objectPosition: "center",
                                                      objectFit: "cover",
                                                    }}
                                                  />
                                                ) : (
                                                  uploadButton
                                                )}
                                              </div>
                                            </Upload>
                                          </>
                                        </div>
                                      </Col>

                                      <Col lg={24} md={24} xs={24}>
                                        <h3>Payment Info</h3>
                                      </Col>
                                      <Col lg={12} md={12} xs={24}>
                                        <Form.Item
                                          label="Name of Bank"
                                          name="bankTitle"
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "Please enter Name of Bank!",
                                            },
                                          ]}
                                        >
                                          <Input
                                            size="large"
                                            placeholder="Enter Name of Bank"
                                            className="web-input"
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col lg={12} md={12} xs={24}>
                                        <Form.Item
                                          label="Bank Account Number"
                                          name="bankAccountNo"
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "Please enter your Account Number!",
                                            },
                                          ]}
                                        >
                                          <Input
                                            size="large"
                                            placeholder="Enter Account Number"
                                            className="web-input"
                                          />
                                        </Form.Item>
                                      </Col>
                                      <Col lg={24} md={24} xs={24}>
                                        <Form.Item
                                          label="Routing Number"
                                          name="routingNo"
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "Please enter Routing Number!",
                                            },
                                          ]}
                                        >
                                          <Input
                                            size="large"
                                            placeholder="Enter Routing Number"
                                            className="web-input"
                                          />
                                        </Form.Item>
                                      </Col>

                                      <Form.Item
                                        style={{ textAlign: "center" }}
                                      >
                                        <Button
                                          type="button"
                                          htmlType="submit"
                                          className="web-btn"
                                          style={{
                                            cursor: "pointer",
                                            margin: "2px",
                                          }}
                                        >
                                          Update Profile
                                        </Button>
                                        <Button
                                          type="button"
                                          htmlType="button"
                                          className="web-btn3"
                                          style={{
                                            cursor: "pointer",
                                            margin: "2px",
                                          }}
                                          onClick={() => navigate("/profile")}
                                        >
                                          Cancel
                                        </Button>
                                      </Form.Item>
                                    </Row>
                                  </Form>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </section>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DropzoneFiltercards;
